import { createTheme } from "@mui/material/styles";

const appTheme = createTheme({
  palette: {
    primary: { main: "#4a1d96", dark: "#35146d", light: "#7250b5", contrastText: "#fff" },
    secondary: { main: "#1976d2" },
    background: { default: "#f6f7fb", paper: "#fff" },
  },
  shape: { borderRadius: 10 },
  typography: { fontFamily: 'Inter, Roboto, "Helvetica Neue", Arial, sans-serif', button: { fontWeight: 700, letterSpacing: "0.02em" } },
  components: {
    MuiCssBaseline: { styleOverrides: { body: { margin: 0, backgroundColor: "#f6f7fb", color: "#1e293b" }, "*": { boxSizing: "border-box" } } },
    MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { borderRadius: 8, textTransform: "none", minHeight: 36, paddingInline: 14 }, contained: { boxShadow: "none", "&:hover": { boxShadow: "0 3px 10px rgba(74,29,150,.25)" } } } },
    MuiTextField: { defaultProps: { variant: "outlined" } },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 8, backgroundColor: "#fff" } } },
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 10 } } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 14 } } },
    MuiTableHead: { styleOverrides: { root: { backgroundColor: "#f8fafc" } } },
    MuiTableCell: { styleOverrides: { head: { fontWeight: 800, color: "#334155", borderBottom: "1px solid #e2e8f0" }, root: { borderBottom: "1px solid #edf0f4" } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 700, borderRadius: 6 } } },
  },
});

export default appTheme;
